import apiConfig from "../config/api";

const apiUserUrl = `${apiConfig.apiUri}api/user`;
const apiTempUrl = `${apiConfig.apiUri}api/temp`;
const getToken = () => localStorage.getItem("AccessToken");

const serieCI = () => sessionStorage.getItem("serieCI");
const usuarioRUT = () => sessionStorage.getItem("rut");
const serialCIActivacion = () => sessionStorage.getItem("serialCIActivacion");
const rutUsuarioActivacion = () =>
  sessionStorage.getItem("rutUsuarioActivacion");

export const validateUserExist = (rutUsuario) =>
  fetch(`${apiUserUrl}/exists/${rutUsuario}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "auth-rut": usuarioRUT(),
    }
  });

export const validateRutApi = (rutUsuario) =>
  fetch(`${apiUserUrl}/rut/${rutUsuario}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "auth-rut": usuarioRUT(),
      "auth-serie-ci": serieCI(),
    }
  });

export const validateRutTemp = (rutUsuario) =>
  fetch(`${apiTempUrl}/user/rut/${rutUsuario}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
    }
  });

export const validateUser = (rutUsuario, authType) =>
  fetch(`${apiUserUrl}/rut/V1/${rutUsuario}/${authType}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "auth-rut": usuarioRUT(),
      "auth-serie-ci": serieCI(),
    }
  });

export const validateEmailApi = (email) =>
  fetch(`${apiUserUrl}/email/${email}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "auth-rut": usuarioRUT(),
      "auth-serie-ci": serieCI(),
    }
  });

export const validateEmailApiJWT = (email) =>
  fetch(`${apiUserUrl}/email/sec/${email}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "auth-jwt": localStorage.getItem("AccessToken"),
    }
  });

export const validateEmailTemp = (email) =>
  fetch(`${apiTempUrl}/user/email/${email}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
    }
  });

export const doValidateSerivice = (rutUsuario, periodo) =>
  fetch(`${apiUserUrl}/validate/${rutUsuario}/${periodo}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "auth-rut": usuarioRUT(),
      "auth-serie-ci": serieCI(),
    }
  });

/**
 * @description Request para consultar el nuevo endpoint de cotizaciones
 * y datos del personales del usuario para el nuevo flujo de registro,
 * ya realiza el mapping del objeto del formulario
 * @author Tony Krikorian <tkrikoram@achs.cl>
 * @param {*} rutUsuario Rut del usuario que se desean consultar las cotizaciones
 * @param {*} periodo Seteado desde el backend, ya no se ocupa en esta llamada
 */
export const doCotizacionesService = () =>
  fetch(`${apiUserUrl}/cotizacion`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "auth-rut": rutUsuarioActivacion(),
      "auth-serie-ci": serialCIActivacion(),
    }
  });

export const conditionAcept = (rutUsuario) =>
  fetch(`${apiUserUrl}/termsandconditionsacceptance`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      accept: "application/json",
      "auth-rut": usuarioRUT(),
      "auth-serie-ci": serieCI(),
    },
    body: `Rut=${rutUsuario}`
  });

// export const sendMail = (email) =>
//   fetch(`${apiConfig.apiUri}api/mail/send`, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
//     },
//     body: JSON.stringify(email),
//     credentials: "same-origin",
//   });

// usado al aceptar una solicitud y el usuario es externo y tiene mas de un rol
// usado al registrar un usuario AD con rol dependiente o independiente
export const createUserAdWithRolesApi = (userRegister) =>
  fetch(`${apiUserUrl}/createwithroles`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      accept: "application/json",
      "auth-rut": usuarioRUT() || rutUsuarioActivacion(),
      "auth-serie-ci": serieCI() || serialCIActivacion(),
    },
    body: JSON.stringify({
      UserType: userRegister.UserType,
      Email: userRegister.Email,
      Password: userRegister.Password,
      FirstName: userRegister.FirstName,
      MiddleName: userRegister.MiddleName,
      IsAchsWorker: userRegister.IsAchsWorker,
      LastName: userRegister.LastName,
      MothersName: userRegister.MothersName,
      Rut: userRegister.Rut,
      Birthdate: userRegister.Birthdate,
      Mobile: userRegister.Phone,
      RelationType: userRegister.RelationType,
      CompanyRut: userRegister.CompanyRut,
      IdRoles: [],
    }),
  });

export const createUserAdWithRolesApiJwt = (userRegister) =>
    fetch(`${apiUserUrl}/createwithrolesjwt`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
            accept: "application/json",
            "auth-jwt": localStorage.getItem("AccessToken"),
        },
        body: JSON.stringify({
            UserType: userRegister.UserType,
            Email: userRegister.Email,
            Password: userRegister.Password,
            FirstName: userRegister.FirstName,
            MiddleName: userRegister.MiddleName,
            IsAchsWorker: userRegister.IsAchsWorker,
            LastName: userRegister.LastName,
            MothersName: userRegister.MothersName,
            Rut: userRegister.Rut,
            Birthdate: userRegister.Birthdate,
            Mobile: userRegister.Phone,
            RelationType: userRegister.RelationTypeCode,
            CompanyRut: userRegister.CompanyRut,
            IdRoles: [],
        }),
    });

export const assignAdminCompanyRolesToUser = (rut) =>
  fetch(`${apiUserUrl}/assignAdminCompaniesRolesToUser/${rut}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      accept: "application/json",
      "auth-rut": usuarioRUT(),
      "auth-serie-ci": serieCI(),
    },
  });

// Usado cuando el usuario tiene el rol de ex achs
export const createUserAdApi = (userRegister) =>
  fetch(`${apiUserUrl}/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      accept: "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "auth-rut": usuarioRUT(),
      "auth-serie-ci": serieCI(),
    },
    body: JSON.stringify({
      UserType: userRegister.UserType,
      Email: userRegister.Email,
      Password: userRegister.Password,
      FirstName: userRegister.FirstName,
      LastName: userRegister.LastName,
      Rut: userRegister.Rut,
      MobiLe: userRegister.Phone,
    }),
  });

export const createTempUserApi = (personalData) =>
  fetch(`${apiTempUrl}/user/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
    },
    body: JSON.stringify({
      RUT: personalData.Rut,
      FirstName: personalData.FirstName,
      MiddleName: personalData.MiddleName,
      LastName: personalData.LastName,
      MothersName: personalData.MothersName,
      Birthdate: personalData.Birthdate,
      Email: personalData.Email,
      Password: personalData.Password,
      CellPhoneNumber:
        personalData.Phone && personalData.Phone.replace("+", ""),
    })
  });

export const validateCompanyId = (runUsuario) =>
  fetch(`${apiUserUrl}/companies/authorized/${runUsuario}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
      "auth-rut": usuarioRUT(),
      "auth-serie-ci": serieCI(),
    }
  });

export const validateActiveToken = (token) =>
  fetch(`${apiUserUrl}/activate`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "auth-rut": usuarioRUT(),
      "auth-serie-ci": serieCI(),
    },
    body: `Token=${token}`
  });

export const deleteUserTemp = (rutUsuario) =>
  fetch(`${apiTempUrl}/user/${rutUsuario}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
    },

    credentials: "same-origin",
  });
